module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-transfer"
  }, [_vm._v("Transferir Crédito")]), _vm._v(" "), _c('div', {
    staticClass: "box-balance"
  }, [_vm._v("\n        Saldo Disponível:\n        "), (_vm.contract) ? _c('b', {
    staticClass: "balance-plus"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentTotalBalance)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20"
  }, [_c('li', {
    class: {
      active: _vm.step == 1
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 3
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), (_vm.step == 1) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    attrs: {
      "id": "searchStep1"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('p', {
    staticClass: "bold text-center no-margin"
  }, [_vm._v("Informe o CPF do Favorecido:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.searchCpf),
      expression: "searchCpf",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpf'),
      expression: "'required|cpf'"
    }, {
      name: "mask-cpf",
      rawName: "v-mask-cpf"
    }],
    staticClass: "form-control search text-center bold",
    attrs: {
      "type": "tel",
      "inputmode": "numeric",
      "pattern": "[0-9]*",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite o CPF",
      "maxlength": "14",
      "autofocus": "",
      "novalidate": "",
      "formnovalidate": ""
    },
    domProps: {
      "value": (_vm.searchCpf)
    },
    on: {
      "change": function($event) {
        _vm.searchCpf = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "search-box inline"
  }, [_c('p', {
    staticClass: "bold text-center no-margin"
  }, [_vm._v("Informe o Contrato do Favorecido:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "only-numbers",
      rawName: "v-only-numbers"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.searchContract),
      expression: "searchContract",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control search text-center bold",
    attrs: {
      "type": "tel",
      "name": "contractIdCred",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite o Contrato",
      "maxlength": "14",
      "autofocus": "",
      "novalidate": "",
      "formnovalidate": ""
    },
    domProps: {
      "value": (_vm.searchContract)
    },
    on: {
      "change": function($event) {
        _vm.searchContract = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-box inline"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "button",
      "id": "cpfSearch"
    },
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_c('i', {
    staticClass: "icon-search align-icon-left-white"
  }), _vm._v("\n                    Buscar\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-20"
  }, [(_vm.status == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e()])]), _vm._v(" "), (_vm.status == 'FOUND') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Dados do Favorecido")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-box-control"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userReceive.cliente),
      expression: "userReceive.cliente"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Nome do Cliente",
      "value": "Nome do cliente.",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.userReceive.cliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userReceive, "cliente", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar Transferência"
    }
  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-purple add",
    attrs: {
      "id": "advanceStep2"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n            Avançar\n            "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('div', {
    attrs: {
      "id": "step2"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('div', {
    staticClass: "row border-row row-fix margin-b20"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('transfer-credit-value', {
    attrs: {
      "step": "1000"
    },
    model: {
      value: (_vm.transfValue),
      callback: function($$v) {
        _vm.transfValue = $$v
      },
      expression: "transfValue"
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("*Taxa de Transferência(" + _vm._s(_vm.fee) + "% sobre o valor): R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedFeeValue),
      expression: "formattedFeeValue"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Valor da Taxa",
      "value": "Valor da Taxa",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.formattedFeeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedFeeValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "id": "backStep1"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar Transferência"
    }
  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-purple add",
    attrs: {
      "disabled": _vm.checkValue,
      "id": "advanceStep3"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('div', {
    attrs: {
      "id": "step3"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Resumo e Confirmação da Transferência")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Dados do Favorecido:")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userReceive.cliente),
      expression: "userReceive.cliente"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Nome do Cliente",
      "value": "Nome do cliente",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.userReceive.cliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userReceive, "cliente", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxIdNumber),
      expression: "taxIdNumber"
    }, {
      name: "mask-cpf",
      rawName: "v-mask-cpf"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "CPF",
      "value": "CPF",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.taxIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxIdNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractIdCred),
      expression: "contractIdCred"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Contrato",
      "value": "Contrato",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.contractIdCred)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contractIdCred = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Dados da Transferência:")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedValue),
      expression: "formattedValue"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "input-transfer-value",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.formattedValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedFeeValue),
      expression: "formattedFeeValue"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Valor da Taxa",
      "value": "Valor da Taxa",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.formattedFeeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedFeeValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedTotal),
      expression: "formattedTotal"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "Total",
      "value": "Total",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.formattedTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "input-box-credit-transfer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "password",
      "name": "senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b20"
  }, [(_vm.status == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar Transferência"
    }
  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success end",
    on: {
      "click": function($event) {
        return _vm.transfer()
      }
    }
  }, [_vm._v("\n              Concluir transferência\n              "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })])], 1)])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-avatar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Identificação do favorecido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-payment-methods"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 2")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Valor da transferência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Resumo e confirmação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-wallets"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Contrato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Valor da Transferência: R$")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Taxa de Transferência: R$")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_c('b', [_vm._v("Total: R$ ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_c('b', [_vm._v("Informe sua senha: ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-f76e9ae0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/credit/transfer-credit.vue
// module id = 2226
// module chunks = 1